import React from 'react';

import {MonitorFiltersFormHandler} from 'entities/monitor';
import IHttpMonitorsFilters from 'features/http/model/HttpMonitor/IHttpMonitorsFilters';
import {stringToBoolean} from 'shared/lib/filterHelper';
import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import HttpMonitorFiltersForm, {IHttpMonitorFiltersForm} from './HttpMonitorFiltersForm/HttpMonitorFiltersForm';

interface IHttpMonitorFiltersFormHandlerProps {
    onSuccess: () => void;
    handleClose: () => void;
}

const buildFilters = ({ok, days, ...rest}: Omit<IHttpMonitorFiltersForm, 'tags' | 'orderBy'>) => {
    const data: IHttpMonitorsFilters = {...rest};

    if (ok !== null && ok !== undefined) {
        data.ok = stringToBoolean(ok);
    }
    if (days !== undefined && days !== null) {
        data.days = Number(days);
    }

    return data;
};

const HttpMonitorFiltersFormHandler: React.FC<IHttpMonitorFiltersFormHandlerProps> = (props) => (
    <MonitorFiltersFormHandler
        {...props}
        FiltersForm={HttpMonitorFiltersForm}
        buildFilters={buildFilters}
        onApplied={() => reachGoal(YM_GOALS.APPLY_FILTER_MONITOR)}
    />
);

export default HttpMonitorFiltersFormHandler;
